import { Chip, ChipProps, Tooltip } from "@mui/material";
import { FC } from "react";

import CachedIcon from "@mui/icons-material/Cached";
import CheckIcon from "@mui/icons-material/Check";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { ObjectStatus } from "../../../../Core/Api/Types/object-status";
import { GetObjectStatusLabel } from "../../../../Utils/helpers";
import { useTranslation } from "react-i18next";

export type AssetStatusProps = {
  small?: boolean;
  outlined?: boolean;
  status: ObjectStatus;
  disabled?: boolean;
  tooltip?: string;
};

const AssetStatus: FC<AssetStatusProps> = (props) => {
  const { t } = useTranslation();
  const { status, outlined = true, small = false, tooltip } = props;
  let color: ChipProps["color"];
  let label = GetObjectStatusLabel(status);
  let icon;

  switch (status) {
    case ObjectStatus.ParsedAndProbbed:
      color = "primary";
      icon = <CachedIcon fontSize="small" />;
      break;
    case ObjectStatus.ToBeQCed:
      color = "warning";
      icon = <VisibilityOutlinedIcon fontSize="small" />;
      break;
    case ObjectStatus.New:
    case ObjectStatus.ToBeDigitalized:
      color = "info";
      icon = <FileUploadOutlinedIcon fontSize="small" />;
      break;
    case ObjectStatus.Accepted:
    case ObjectStatus.Delivered:
      color = "success";
      icon = <CheckIcon fontSize="small" />;
      break;
    /*case ObjectStatus.Deleted:
      color = "default";
      icon = <ArchiveOutlinedIcon fontSize="small" />;
      label = "Archived";
      break;*/
    case ObjectStatus.Rejected:
    case ObjectStatus.RejectedAuto:
      color = "error";
      icon = <ErrorOutlineIcon fontSize="small" />;
      break;
    case ObjectStatus.Deleted:
      color = "default";
      icon = <CancelOutlinedIcon fontSize="small" />;
      break;
    case ObjectStatus.WaitingForMEZZReference:
      color = "default";
      icon = <HourglassEmptyIcon fontSize="small" />;
      break;
    case ObjectStatus.MissingMetadata:
      color = "warning";
      icon = <HourglassEmptyIcon fontSize="small" />;
      break;
    default:
      color = "default";
      icon = <HourglassEmptyIcon fontSize="small" />;
      break;
  }

  if (props.disabled || status === ObjectStatus.Disabled) {
    color = "default";
    icon = <CancelOutlinedIcon fontSize="small" />;
    label = t("common:disabled");
  }

  const chip = (
    <Chip
      size={small ? "small" : "medium"}
      variant={outlined ? "outlined" : "filled"}
      label={label}
      color={color}
      icon={icon}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};

export default AssetStatus;
